// extracted by mini-css-extract-plugin
module.exports = {"container":"GeneralStatisticsAllForm_container__h2ilp","loadOuter":"GeneralStatisticsAllForm_loadOuter__2r58w"};